import api from "./index";

export interface Allergy {
  id: string;
  name: string;
  createdAt: string;
  updatedAt: string;
}

export interface AllergyCreateUpdatePayload {
  id?: string;
  name: string;
}

export const getAllergies = async (): Promise<{ data: Allergy[] }> => {
  const response = await api.get("/allergy/getAll");
  return response.data;
};

export const createOrUpdateAllergy = async (
  payload: AllergyCreateUpdatePayload
) => {
  return api.post("/allergy/create-update", payload);
};

export const deleteAllergy = async (id: string) => {
  return api.get(`/allergy/delete/${id}`);
};